
define('text!modules/targeting/pixel/templates/bin_item.html',[],function () { return '<div class="column name">\n    <div class="text active" data-action="{{action}}">{{path}}<span class="strong">{{full_name}}</span></div>\n</div>\n<div class="column recency">\n    <span class="item-c"><!--DDL Goes Here--></span>\n</div>';});

